<template>
  <span class="fshr-loadingSkeleton" />
</template>

<script>
export default {
  name: "loading-skeleton",
};
</script>
